import { getRecentProjects } from "./recentProjects";

let currentSessionProject: string | null = null;

export function setCurrentSessionProject(path: string): void {
  currentSessionProject = path;
}

export function clearCurrentSessionProject(): void {
  currentSessionProject = null;
}

export function getCurrentSessionProject(): string | null {
  return currentSessionProject;
}

export async function getCurrentProjectPath(): Promise<string | null> {
  return currentSessionProject;
}

export async function getMostRecentProjectPath(): Promise<string | null> {
  if (currentSessionProject) {
    return currentSessionProject;
  }

  try {
    const projects = await getRecentProjects();
    if (projects.length > 0) {
      return projects[0].path;
    }
    return null;
  } catch (error) {
    // console.error("Error getting most recent project:", error);
    return null;
  }
}

export async function getCurrentProject() {
  try {
    const projects = await getRecentProjects();
    if (projects.length > 0) {
      return projects[0];
    }
    return null;
  } catch (error) {
    // console.error("Error getting current project:", error);
    return null;
  }
}
